import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_YEAR } from "../graphql/mutations";
import {
  INTROLES,
  VACROLES,
  NHCROLES,
  DAF1ROLES,
  DAF2ROLES,
  DAF3ROLES,
  BED1ROLES,
  BED2ROLES,
  LNKRROLES,
  LNKNROLES,
  LNKIROLES,
  IEVRROLES,
  IEVNROLES,
  IEVIROLES,
  COPROLES,
  COPRROLES,
  NTWUROLES,
  NTWSROLES,
  NTWBROLES,
  CONROLES,
  ISCROLES,
  EXPROLES,
  STFROLES,
  FSCROLES,
  VC1ROLES,
  VC2ROLES,
  VC3ROLES,
  VC4ROLES,
  VC5ROLES,
  VC6ROLES,
  MMEROLES,
  RVNROLES,
  RVN1ROLES,
  PFTROLES,
  PFT1ROLES,
  BSTCROLES,
  BSTFROLES,
} from "../graphql/queries";
import CustomSelect from "./CustomSelect";
import { Link } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
const axios = require("axios");

function StartupdatJear(props) {
  const confirmationCode = props.match.params.code;
  const startupId = props.match.params.startupId;

  const [valid, setValid] = useState(false);
  const [done, setDone] = useState(false);

  // ????
  useEffect(() => {
    const confirmationUrl =
      process.env.REACT_APP_MAIL_CONFIRMATION_PROFILE_CONFIRMATION_URL ||
      "https://f1j07exi8h.execute-api.eu-central-1.amazonaws.com/dev/profile-confirmation";
    fetch(`${confirmationUrl}?code=${confirmationCode}&startupid=${startupId}`)
      .then(response => {
        setValid(response.status === 200);
        setDone(true);
      })
      .catch((_) => setDone(true));
  }, [confirmationCode, startupId]);

  // Fetch RMOROLES
  const [emp, setName] = useState("");

  // Fetch INTROLES
  const [intranges, setIntranges] = useState();
  const intrangesQuery = useQuery(INTROLES);
  useEffect(() => {
    if (intrangesQuery?.data) {
      const dataReceived = intrangesQuery?.data.intRanges?.data.map(intranges => ({
        value: intranges.id,
        label: intranges.attributes.value,
      }));

      setIntranges(dataReceived);
    }
  }, [intrangesQuery?.data, intrangesQuery.error]);

  // Fetch VACROLES
  const [vacranges, setVacranges] = useState();
  const vacrangesQuery = useQuery(VACROLES);
  useEffect(() => {
    if (vacrangesQuery?.data) {
      const dataReceived = vacrangesQuery?.data.vacRanges?.data.map(vacranges => ({
        value: vacranges.id,
        label: vacranges.attributes.value,
      }));

      setVacranges(dataReceived);
    }
  }, [vacrangesQuery?.data, vacrangesQuery.error]);

  // Fetch vac1
  const [vac1, setVac1] = useState("");

  // Fetch NHCROLES
  const [nhcranges, setNhcranges] = useState();
  const nhcrangesQuery = useQuery(NHCROLES);
  useEffect(() => {
    if (nhcrangesQuery?.data) {
      const dataReceived = nhcrangesQuery?.data.nhcRanges?.data.map(nhcranges => ({
        value: nhcranges.id,
        label: nhcranges.attributes.value,
      }));

      setNhcranges(dataReceived);
    }
  }, [nhcrangesQuery?.data, nhcrangesQuery.error]);

  // Fetch CUSB
  const [cusb, setCusb] = useState("");

  // Fetch CUSER
  const [cuse, setCuse] = useState("");

  // Fetch CUSN
  const [cusn, setCusn] = useState("");

  // Fetch DAF1ROLES
  const [daf1ranges, setDaf1ranges] = useState();
  const daf1rangesQuery = useQuery(DAF1ROLES);
  useEffect(() => {
    if (daf1rangesQuery?.data) {
      const dataReceived = daf1rangesQuery?.data.daf1Ranges?.data.map(daf1ranges => ({
        value: daf1ranges.id,
        label: daf1ranges.attributes.value,
      }));

      setDaf1ranges(dataReceived);
    }
  }, [daf1rangesQuery?.data, daf1rangesQuery.error]);

  // Fetch DAF2ROLES
  const [daf2ranges, setDaf2ranges] = useState();
  const daf2rangesQuery = useQuery(DAF2ROLES);
  useEffect(() => {
    if (daf2rangesQuery?.data) {
      const dataReceived = daf2rangesQuery?.data.daf2Ranges?.data.map(daf2ranges => ({
        value: daf2ranges.id,
        label: daf2ranges.attributes.value,
      }));

      setDaf2ranges(dataReceived);
    }
  }, [daf2rangesQuery?.data, daf2rangesQuery.error]);

  // Fetch DAF3ROLES
  const [daf3ranges, setDaf3ranges] = useState();
  const daf3rangesQuery = useQuery(DAF3ROLES);
  useEffect(() => {
    if (daf3rangesQuery?.data) {
      const dataReceived = daf3rangesQuery?.data.daf3Ranges?.data.map(daf3ranges => ({
        value: daf3ranges.id,
        label: daf3ranges.attributes.value,
      }));

      setDaf3ranges(dataReceived);
    }
  }, [daf3rangesQuery?.data, daf3rangesQuery.error]);

  // Fetch BED1ROLES
  const [bed1ranges, setBed1ranges] = useState();
  const bed1rangesQuery = useQuery(BED1ROLES);
  useEffect(() => {
    if (bed1rangesQuery?.data) {
      const dataReceived = bed1rangesQuery?.data.bed1Ranges?.data.map(bed1ranges => ({
        value: bed1ranges.id,
        label: bed1ranges.attributes.value,
      }));

      setBed1ranges(dataReceived);
    }
  }, [bed1rangesQuery?.data, bed1rangesQuery.error]);

  // Fetch BED2ROLES
  const [bed2ranges, setBed2ranges] = useState();
  const bed2rangesQuery = useQuery(BED2ROLES);
  useEffect(() => {
    if (bed2rangesQuery?.data) {
      const dataReceived = bed2rangesQuery?.data.bed2Ranges?.data.map(bed2ranges => ({
        value: bed2ranges.id,
        label: bed2ranges.attributes.value,
      }));

      setBed2ranges(dataReceived);
    }
  }, [bed2rangesQuery?.data, bed2rangesQuery.error]);

  // Fetch LNKRROLES
  const [lnkRranges, setLnkRranges] = useState();
  const lnkRrangesQuery = useQuery(LNKRROLES);
  useEffect(() => {
    if (lnkRrangesQuery?.data) {
      const dataReceived = lnkRrangesQuery?.data.lnkRRanges?.data.map(lnkRranges => ({
        value: lnkRranges.id,
        label: lnkRranges.attributes.value,
      }));

      setLnkRranges(dataReceived);
    }
  }, [lnkRrangesQuery?.data, lnkRrangesQuery.error]);

  // Fetch LNKNROLES
  const [lnkNranges, setLnkNranges] = useState();
  const lnkNrangesQuery = useQuery(LNKNROLES);
  useEffect(() => {
    if (lnkNrangesQuery?.data) {
      const dataReceived = lnkNrangesQuery?.data.lnkNRanges?.data.map(lnkNranges => ({
        value: lnkNranges.id,
        label: lnkNranges.attributes.value,
      }));

      setLnkNranges(dataReceived);
    }
  }, [lnkNrangesQuery?.data, lnkNrangesQuery.error]);

  // Fetch LNKIROLES
  const [lnkIranges, setLnkIranges] = useState();
  const lnkIrangesQuery = useQuery(LNKIROLES);
  useEffect(() => {
    if (lnkIrangesQuery?.data) {
      const dataReceived = lnkIrangesQuery?.data.lnkIRanges?.data.map(lnkIranges => ({
        value: lnkIranges.id,
        label: lnkIranges.attributes.value,
      }));

      setLnkIranges(dataReceived);
    }
  }, [lnkIrangesQuery?.data, lnkIrangesQuery.error]);

  // Fetch IEVRROLES
  const [ievRranges, setIevRranges] = useState();
  const ievRrangesQuery = useQuery(IEVRROLES);
  useEffect(() => {
    if (ievRrangesQuery?.data) {
      const dataReceived = ievRrangesQuery?.data.ievRRanges?.data.map(ievRranges => ({
        value: ievRranges.id,
        label: ievRranges.attributes.value,
      }));

      setIevRranges(dataReceived);
    }
  }, [ievRrangesQuery?.data, ievRrangesQuery.error]);

  // Fetch IEVNROLES
  const [ievNranges, setIevNranges] = useState();
  const ievNrangesQuery = useQuery(IEVNROLES);
  useEffect(() => {
    if (ievNrangesQuery?.data) {
      const dataReceived = ievNrangesQuery?.data.ievNRanges?.data.map(ievNranges => ({
        value: ievNranges.id,
        label: ievNranges.attributes.value,
      }));

      setIevNranges(dataReceived);
    }
  }, [ievNrangesQuery?.data, ievNrangesQuery.error]);

  // Fetch IEVIROLES
  const [ievIranges, setIevIranges] = useState();
  const ievIrangesQuery = useQuery(IEVIROLES);
  useEffect(() => {
    if (ievIrangesQuery?.data) {
      const dataReceived = ievIrangesQuery?.data.ievIRanges?.data.map(ievIranges => ({
        value: ievIranges.id,
        label: ievIranges.attributes.value,
      }));

      setIevIranges(dataReceived);
    }
  }, [ievIrangesQuery?.data, ievIrangesQuery.error]);

  // Fetch COPROLES
  const [copranges, setcopranges] = useState();
  const coprangesQuery = useQuery(COPROLES);
  useEffect(() => {
    if (coprangesQuery?.data) {
      const dataReceived = coprangesQuery?.data.copRanges?.data.map(copranges => ({
        value: copranges.id,
        label: copranges.attributes.value,
      }));

      setcopranges(dataReceived);
    }
  }, [coprangesQuery?.data, coprangesQuery.error]);

  // Fetch COPROLES
  const [copRranges, setcopRranges] = useState();
  const copRrangesQuery = useQuery(COPRROLES);
  useEffect(() => {
    if (copRrangesQuery?.data) {
      const dataReceived = copRrangesQuery?.data.copRRanges?.data.map(copRranges => ({
        value: copRranges.id,
        label: copRranges.attributes.value,
      }));

      setcopRranges(dataReceived);
    }
  }, [copRrangesQuery?.data, copRrangesQuery.error]);

  // Fetch NTWUROLES
  const [ntwUranges, setntwUranges] = useState();
  const ntwUrangesQuery = useQuery(NTWUROLES);
  useEffect(() => {
    if (ntwUrangesQuery?.data) {
      const dataReceived = ntwUrangesQuery?.data.ntwURanges?.data.map(ntwUranges => ({
        value: ntwUranges.id,
        label: ntwUranges.attributes.value,
      }));

      setntwUranges(dataReceived);
    }
  }, [ntwUrangesQuery?.data, ntwUrangesQuery.error]);

  // Fetch NTWSROLES
  const [ntwSranges, setntwSranges] = useState();
  const ntwSrangesQuery = useQuery(NTWSROLES);
  useEffect(() => {
    if (ntwSrangesQuery?.data) {
      const dataReceived = ntwSrangesQuery?.data.ntwSRanges?.data.map(ntwSranges => ({
        value: ntwSranges.id,
        label: ntwSranges.attributes.value,
      }));

      setntwSranges(dataReceived);
    }
  }, [ntwSrangesQuery?.data, ntwSrangesQuery.error]);

  // Fetch NTWBROLES
  const [ntwBranges, setntwBranges] = useState();
  const ntwBrangesQuery = useQuery(NTWBROLES);
  useEffect(() => {
    if (ntwBrangesQuery?.data) {
      const dataReceived = ntwBrangesQuery?.data.ntwBRanges?.data.map(ntwBranges => ({
        value: ntwBranges.id,
        label: ntwBranges.attributes.value,
      }));

      setntwBranges(dataReceived);
    }
  }, [ntwBrangesQuery?.data, ntwBrangesQuery.error]);

  // Fetch CONROLES
  const [conranges, setconranges] = useState();
  const conrangesQuery = useQuery(CONROLES);
  useEffect(() => {
    if (conrangesQuery?.data) {
      const dataReceived = conrangesQuery?.data.conRanges?.data.map(conranges => ({
        value: conranges.id,
        label: conranges.attributes.value,
      }));

      setconranges(dataReceived);
    }
  }, [conrangesQuery?.data, conrangesQuery.error]);

  // Fetch ISCROLES
  const [iscranges, setiscranges] = useState();
  const iscrangesQuery = useQuery(ISCROLES);
  useEffect(() => {
    if (iscrangesQuery?.data) {
      const dataReceived = iscrangesQuery?.data.iscRanges?.data.map(iscranges => ({
        value: iscranges.id,
        label: iscranges.attributes.value,
      }));

      setiscranges(dataReceived);
    }
  }, [iscrangesQuery?.data, iscrangesQuery.error]);

  // Fetch EXPROLES
  const [expranges, setexpranges] = useState();
  const exprangesQuery = useQuery(EXPROLES);
  useEffect(() => {
    if (exprangesQuery?.data) {
      const dataReceived = exprangesQuery?.data.expRanges?.data.map(expranges => ({
        value: expranges.id,
        label: expranges.attributes.value,
      }));

      setexpranges(dataReceived);
    }
  }, [exprangesQuery?.data, exprangesQuery.error]);

  // Fetch STFROLES
  const [stFranges, setstFranges] = useState();
  const stFrangesQuery = useQuery(STFROLES);
  useEffect(() => {
    if (stFrangesQuery?.data) {
      const dataReceived = stFrangesQuery?.data.stFRanges?.data.map(stFranges => ({
        value: stFranges.id,
        label: stFranges.attributes.value,
      }));

      setstFranges(dataReceived);
    }
  }, [stFrangesQuery?.data, stFrangesQuery.error]);

  // Fetch FSCROLES
  const [fscranges, setfscranges] = useState();
  const fscrangesQuery = useQuery(FSCROLES);
  useEffect(() => {
    if (fscrangesQuery?.data) {
      const dataReceived = fscrangesQuery?.data.fscRanges?.data.map(fscranges => ({
        value: fscranges.id,
        label: fscranges.attributes.value,
      }));

      setfscranges(dataReceived);
    }
  }, [fscrangesQuery?.data, fscrangesQuery.error]);

  // Fetch VC1ROLES
  const [vc1ranges, setvc1ranges] = useState();
  const vc1rangesQuery = useQuery(VC1ROLES);
  useEffect(() => {
    if (vc1rangesQuery?.data) {
      const dataReceived = vc1rangesQuery?.data.vc1Ranges?.data.map(vc1ranges => ({
        value: vc1ranges.id,
        label: vc1ranges.attributes.value,
      }));

      setvc1ranges(dataReceived);
    }
  }, [vc1rangesQuery?.data, vc1rangesQuery.error]);

  // Fetch VC2ROLES
  const [vc2ranges, setvc2ranges] = useState();
  const vc2rangesQuery = useQuery(VC2ROLES);
  useEffect(() => {
    if (vc2rangesQuery?.data) {
      const dataReceived = vc2rangesQuery?.data.vc2Ranges?.data.map(vc2ranges => ({
        value: vc2ranges.id,
        label: vc2ranges.attributes.value,
      }));

      setvc2ranges(dataReceived);
    }
  }, [vc2rangesQuery?.data, vc2rangesQuery.error]);

  // Fetch VC3ROLES
  const [vc3ranges, setvc3ranges] = useState();
  const vc3rangesQuery = useQuery(VC3ROLES);
  useEffect(() => {
    if (vc3rangesQuery?.data) {
      const dataReceived = vc3rangesQuery?.data.vc3Ranges?.data.map(vc3ranges => ({
        value: vc3ranges.id,
        label: vc3ranges.attributes.value,
      }));

      setvc3ranges(dataReceived);
    }
  }, [vc3rangesQuery?.data, vc3rangesQuery.error]);

  // Fetch VC4ROLES
  const [vc4ranges, setvc4ranges] = useState();
  const vc4rangesQuery = useQuery(VC4ROLES);
  useEffect(() => {
    if (vc4rangesQuery?.data) {
      const dataReceived = vc4rangesQuery?.data.vc4Ranges?.data.map(vc4ranges => ({
        value: vc4ranges.id,
        label: vc4ranges.attributes.value,
      }));

      setvc4ranges(dataReceived);
    }
  }, [vc4rangesQuery?.data, vc4rangesQuery.error]);

  // Fetch VC5ROLES
  const [vc5ranges, setvc5ranges] = useState();
  const vc5rangesQuery = useQuery(VC5ROLES);
  useEffect(() => {
    if (vc5rangesQuery?.data) {
      const dataReceived = vc5rangesQuery?.data.vc5Ranges?.data.map(vc5ranges => ({
        value: vc5ranges.id,
        label: vc5ranges.attributes.value,
      }));

      setvc5ranges(dataReceived);
    }
  }, [vc5rangesQuery?.data, vc5rangesQuery.error]);

  // Fetch VC6ROLES
  const [vc6ranges, setvc6ranges] = useState();
  const vc6rangesQuery = useQuery(VC6ROLES);
  useEffect(() => {
    if (vc6rangesQuery?.data) {
      const dataReceived = vc6rangesQuery?.data.vc6Ranges?.data.map(vc6ranges => ({
        value: vc6ranges.id,
        label: vc6ranges.attributes.value,
      }));

      setvc6ranges(dataReceived);
    }
  }, [vc6rangesQuery?.data, vc6rangesQuery.error]);

  // Fetch MMEROLES
  const [mmeranges, setmmeranges] = useState();
  const mmerangesQuery = useQuery(MMEROLES);
  useEffect(() => {
    if (mmerangesQuery?.data) {
      const dataReceived = mmerangesQuery?.data.mmeRanges?.data.map(mmeranges => ({
        value: mmeranges.id,
        label: mmeranges.attributes.value,
      }));

      setmmeranges(dataReceived);
    }
  }, [mmerangesQuery?.data, mmerangesQuery.error]);

  // Fetch PFT2
  const [pft2, setPft2] = useState("");

  // Fetch RVNROLES
  const [rvnranges, setRvnranges] = useState();
  const rvnrangesQuery = useQuery(RVNROLES);
  useEffect(() => {
    if (rvnrangesQuery?.data) {
      const dataReceived = rvnrangesQuery?.data.rvnRanges?.data.map(rvnranges => ({
        value: rvnranges.id,
        label: rvnranges.attributes.value,
      }));

      setRvnranges(dataReceived);
    }
  }, [rvnrangesQuery?.data, rvnrangesQuery.error]);

  // Fetch RVN1ROLES
  const [rvn1ranges, setRvn1ranges] = useState();
  const rvn1rangesQuery = useQuery(RVN1ROLES);
  useEffect(() => {
    if (rvn1rangesQuery?.data) {
      const dataReceived = rvn1rangesQuery?.data.rvn1Ranges?.data.map(rvn1ranges => ({
        value: rvn1ranges.id,
        label: rvn1ranges.attributes.value,
      }));

      setRvn1ranges(dataReceived);
    }
  }, [rvn1rangesQuery?.data, rvn1rangesQuery.error]);

  // Fetch PFTROLES
  const [pftranges, setPftranges] = useState();
  const pftrangesQuery = useQuery(PFTROLES);
  useEffect(() => {
    if (pftrangesQuery?.data) {
      const dataReceived = pftrangesQuery?.data.pftRanges?.data.map(pftranges => ({
        value: pftranges.id,
        label: pftranges.attributes.value,
      }));

      setPftranges(dataReceived);
    }
  }, [pftrangesQuery?.data, pftrangesQuery.error]);

  // Fetch PFT1ROLES
  const [pft1ranges, setPft1ranges] = useState();
  const pft1rangesQuery = useQuery(PFT1ROLES);
  useEffect(() => {
    if (pft1rangesQuery?.data) {
      const dataReceived = pft1rangesQuery?.data.pft1Ranges?.data.map(pft1ranges => ({
        value: pft1ranges.id,
        label: pft1ranges.attributes.value,
      }));

      setPft1ranges(dataReceived);
    }
  }, [pft1rangesQuery?.data, pft1rangesQuery.error]);

  // Fetch BSTCROLES
  const [bstCranges, setBstCranges] = useState();
  const bstCrangesQuery = useQuery(BSTCROLES);
  useEffect(() => {
    if (bstCrangesQuery?.data) {
      const dataReceived = bstCrangesQuery?.data.bstCRanges?.data.map(bstCranges => ({
        value: bstCranges.id,
        label: bstCranges.attributes.value,
      }));

      setBstCranges(dataReceived);
    }
  }, [bstCrangesQuery?.data, bstCrangesQuery.error]);

  // Fetch BSTFROLES
  const [bstFranges, setBstFranges] = useState();
  const bstFrangesQuery = useQuery(BSTFROLES);
  useEffect(() => {
    if (bstFrangesQuery?.data) {
      const dataReceived = bstFrangesQuery?.data.bstFRanges?.data.map(bstFranges => ({
        value: bstFranges.id,
        label: bstFranges.attributes.value,
      }));

      setBstFranges(dataReceived);
    }
  }, [bstFrangesQuery?.data, bstFrangesQuery.error]);

  /* intrange */
  const [intrange, setIntrange] = useState("");
  const [intrangeError, setIntrangeError] = useState("");
  function handleChangeintrange(selectedOption) {
    setIntrange(selectedOption.value);
    setIntrangeError("");
  }

  /* vacrange */
  const [vacrange, setVacrange] = useState("");
  const [vacrangeError, setVacrangeError] = useState("");
  function handleChangevacrange(selectedOption) {
    setVacrange(selectedOption.value);
    setVacrangeError("");
  }

  /* nhcrange */
  const [nhcrange, setNhcrange] = useState("");
  const [nhcrangeError, setNhcrangeError] = useState("");
  function handleChangenhcrange(selectedOption) {
    setNhcrange(selectedOption.value);
    setNhcrangeError("");
  }

  /* daf1range */
  const [daf1range, setDaf1range] = useState("");
  const [daf1rangeError, setDaf1rangeError] = useState("");
  function handleChangedaf1range(selectedOption) {
    setDaf1range(selectedOption.value);
    setDaf1rangeError("");
  }

  /* daf2range */
  const [daf2range, setDaf2range] = useState("");
  const [daf2rangeError, setDaf2rangeError] = useState("");
  function handleChangedaf2range(selectedOption) {
    setDaf2range(selectedOption.value);
    setDaf2rangeError("");
  }

  /* daf3range */
  const [daf3range, setDaf3range] = useState("");
  const [daf3rangeError, setDaf3rangeError] = useState("");
  function handleChangedaf3range(selectedOption) {
    setDaf3range(selectedOption.value);
    setDaf3rangeError("");
  }

  /*bed1range*/
  const [bed1range, setBed1range] = useState("");
  const [bed1rangeError, setBed1rangeError] = useState("");
  function handleChangeBed1range(selectedOption) {
    setBed1range(selectedOption.value);
    setBed1rangeError("");
  }

  /*bed2range*/
  const [bed2range, setBed2range] = useState("");
  const [bed2rangeError, setBed2rangeError] = useState("");
  function handleChangeBed2range(selectedOption) {
    setBed2range(selectedOption.value);
    setBed2rangeError("");
  }

  /* lnkrrange */
  const [lnkRrange, setLnkRrange] = useState("");
  const [lnkRrangeError, setLnkRrangeError] = useState("");
  function handleChangelnkRrange(selectedOption) {
    setLnkRrange(selectedOption.value);
    setLnkRrangeError("");
  }

  /* lnknrange */
  const [lnkNrange, setLnkNrange] = useState("");
  const [lnkNrangeError, setLnkNrangeError] = useState("");
  function handleChangelnkNrange(selectedOption) {
    setLnkNrange(selectedOption.value);
    setLnkNrangeError("");
  }

  /* lnkirange */
  const [lnkIrange, setLnkIrange] = useState("");
  const [lnkIrangeError, setLnkIrangeError] = useState("");
  function handleChangelnkIrange(selectedOption) {
    setLnkIrange(selectedOption.value);
    setLnkIrangeError("");
  }

  /* ievrrange */
  const [ievRrange, setIevRrange] = useState("");
  const [ievRrangeError, setIevRrangeError] = useState("");
  function handleChangeievRrange(selectedOption) {
    setIevRrange(selectedOption.value);
    setIevRrangeError("");
  }

  /* ievnrange */
  const [ievNrange, setIevNrange] = useState("");
  const [ievNrangeError, setIevNrangeError] = useState("");
  function handleChangeievNrange(selectedOption) {
    setIevNrange(selectedOption.value);
    setIevNrangeError("");
  }

  /* ievirange */
  const [ievIrange, setIevIrange] = useState("");
  const [ievIrangeError, setIevIrangeError] = useState("");
  function handleChangeievIrange(selectedOption) {
    setIevIrange(selectedOption.value);
    setIevIrangeError("");
  }

  /* coprange */
  const [coprange, setCoprange] = useState("");
  const [coprangeError, setCoprangeError] = useState("");
  function handleChangecoprange(selectedOption) {
    setCoprange(selectedOption.value);
    setCoprangeError("");
  }

  /* copRrange */
  const [copRrange, setCopRrange] = useState("");
  const [copRrangeError, setCopRrangeError] = useState("");
  function handleChangecopRrange(selectedOption) {
    setCopRrange(selectedOption.value);
    setCopRrangeError("");
  }

  /* ntwUrange */
  const [ntwUrange, setNtwUrange] = useState("");
  const [ntwUrangeError, setNtwUrangeError] = useState("");
  function handleChangentwUrange(selectedOption) {
    setNtwUrange(selectedOption.value);
    setNtwUrangeError("");
  }

  /* ntwSrange */
  const [ntwSrange, setNtwSrange] = useState("");
  const [ntwSrangeError, setNtwSrangeError] = useState("");
  function handleChangentwSrange(selectedOption) {
    setNtwSrange(selectedOption.value);
    setNtwSrangeError("");
  }

  /* ntwBrange */
  const [ntwBrange, setNtwBrange] = useState("");
  const [ntwBrangeError, setNtwBrangeError] = useState("");
  function handleChangentwBrange(selectedOption) {
    setNtwBrange(selectedOption.value);
    setNtwBrangeError("");
  }

  // ntwM
  const [ntwM, setntwM] = useState("");

  /* conrange */
  const [conrange, setConrange] = useState("");
  const [conrangeError, setConrangeError] = useState("");
  function handleChangeconrange(selectedOption) {
    setConrange(selectedOption.value);
    setConrangeError("");
  }

  /* iscrange */
  const [iscrange, setIscrange] = useState("");
  const [iscrangeError, setIscrangeError] = useState("");
  function handleChangeiscrange(selectedOption) {
    setIscrange(selectedOption.value);
    setIscrangeError("");
  }

  /* exprange */
  const [exprange, setExprange] = useState("");
  const [exprangeError, setExprangeError] = useState("");
  function handleChangeexprange(selectedOption) {
    setExprange(selectedOption.value);
    setExprangeError("");
  }

  /* stfrange */
  const [stFrange, setStFrange] = useState("");
  const [stFrangeError, setStFrangeError] = useState("");
  function handleChangestFrange(selectedOption) {
    setStFrange(selectedOption.value);
    setStFrangeError("");
  }

  /* fscrange */
  const [fscrange, setfscrange] = useState("");
  const [fscrangeError, setfscrangeError] = useState("");
  function handleChangefscrange(selectedOption) {
    setfscrange(selectedOption.value);
    setfscrangeError("");
  }

  /* vc1range */
  const [vc1range, setvc1range] = useState("");
  const [vc1rangeError, setvc1rangeError] = useState("");
  function handleChangevc1range(selectedOption) {
    setvc1range(selectedOption.value);
    setvc1rangeError("");
  }

  /* vc2range */
  const [vc2range, setvc2range] = useState("");
  const [vc2rangeError, setvc2rangeError] = useState("");
  function handleChangevc2range(selectedOption) {
    setvc2range(selectedOption.value);
    setvc2rangeError("");
  }
  /* vc3range */
  const [vc3range, setvc3range] = useState("");
  const [vc3rangeError, setvc3rangeError] = useState("");
  function handleChangevc3range(selectedOption) {
    setvc3range(selectedOption.value);
    setvc3rangeError("");
  }
  /* vc4range */
  const [vc4range, setvc4range] = useState("");
  const [vc4rangeError, setvc4rangeError] = useState("");
  function handleChangevc4range(selectedOption) {
    setvc4range(selectedOption.value);
    setvc4rangeError("");
  }

  /* vc5range */
  const [vc5range, setvc5range] = useState("");
  const [vc5rangeError, setvc5rangeError] = useState("");
  function handleChangevc5range(selectedOption) {
    setvc5range(selectedOption.value);
    setvc5rangeError("");
  }

  /* vc6range */
  const [vc6range, setvc6range] = useState("");
  const [vc6rangeError, setvc6rangeError] = useState("");
  function handleChangevc6range(selectedOption) {
    setvc6range(selectedOption.value);
    setvc6rangeError("");
  }

  /* mmerange */
  const [mmerange, setmmerange] = useState("");
  const [mmerangeError, setmmerangeError] = useState("");
  function handleChangemmerange(selectedOption) {
    setmmerange(selectedOption.value);
    setmmerangeError("");
  }

  /* rvnrange */
  const [rvnrange, setRvnrange] = useState("");
  const [rvnrangeError, setRvnrangeError] = useState("");
  function handleChangervnrange(selectedOption) {
    setRvnrange(selectedOption.value);
    setRvnrangeError("");
  }

  /* rvn1range */
  const [rvn1range, setRvn1range] = useState("");
  const [rvn1rangeError, setRvn1rangeError] = useState("");
  function handleChangervn1range(selectedOption) {
    setRvn1range(selectedOption.value);
    setRvn1rangeError("");
  }

  /* pftrange */
  const [pftrange, setPftrange] = useState("");
  const [pftrangeError, setPftrangeError] = useState("");
  function handleChangePftrange(selectedOption) {
    setPftrange(selectedOption.value);
    setPftrangeError("");
  }

  /* pft1range */
  const [pft1range, setPft1range] = useState("");
  const [pft1rangeError, setPft1rangeError] = useState("");
  function handleChangePft1range(selectedOption) {
    setPft1range(selectedOption.value);
    setPft1rangeError("");
  }

  /* bstcrange */
  const [bstCrange, setBstCrange] = useState("");
  const [bstCrangeError, setBstCrangeError] = useState("");
  function handleChangeBstCrange(selectedOption) {
    setBstCrange(selectedOption.value);
    setBstCrangeError("");
  }

  /* bstfrange */
  const [bstFrange, setBstFrange] = useState("");
  const [bstFrangeError, setBstFrangeError] = useState("");
  function handleChangeBstFrange(selectedOption) {
    setBstFrange(selectedOption.value);
    setBstFrangeError("");
  }

  const [success, setSuccess] = useState();
  const [createStartupdataJear, { loadingStartupdataJear }] = useMutation(
    CREATE_YEAR, {
    onCompleted: providerData => {
      setSuccess(true);
    },
  });
  const handleSubmit = e => {
    e.preventDefault();
    if (intrange === "") {
      setIntrangeError("Please select a valid entry.");
      document.getElementById("select-Int").scrollIntoView();
    } else if (vacrange === "") {
      setVacrangeError("Please select a valid entry.");
      document.getElementById("select-Vac").scrollIntoView();
    } else if (nhcrange === "") {
      setNhcrangeError("Please select a valid entry.");
      document.getElementById("select-Nhc").scrollIntoView();
    } else if (lnkRrange === "") {
      setLnkRrangeError("Please select a valid entry.");
      document.getElementById("select-Lnkr").scrollIntoView();
    } else if (lnkNrange === "") {
      setLnkNrangeError("Please select a valid entry.");
    } else if (lnkIrange === "") {
      setLnkIrangeError("Please select a valid entry.");
      document.getElementById("select-Lnki").scrollIntoView();
    } else if (ievRrange === "") {
      setIevRrange("Please select a valid entry.");
      document.getElementById("select-Ievr").scrollIntoView();
    } else if (ievNrange === "") {
      setIevNrange("Please select a valid entry.");
      document.getElementById("select-Ievn").scrollIntoView();
    } else if (ievIrange === "") {
      setIevIrange("Please select a valid entry.");
      document.getElementById("select-Ievi").scrollIntoView();
    } else if (coprange === "") {
      setCoprange("Please select a valid entry.");
      document.getElementById("select-Cop").scrollIntoView();
    } else if (copRrange === "") {
      setCopRrange("Please select a valid entry.");
      document.getElementById("select-CopR").scrollIntoView();
    } else if (ntwUrange === "") {
      setNtwUrange("Please select a valid entry.");
      document.getElementById("select-NtwU").scrollIntoView();
    } else if (ntwSrange === "") {
      setNtwSrange("Please select a valid entry.");
      document.getElementById("select-NtwS").scrollIntoView();
    } else if (ntwBrange === "") {
      setNtwBrange("Please select a valid entry.");
      document.getElementById("select-NtwB").scrollIntoView();
    } else if (conrange === "") {
      setConrange("Please select a valid entry.");
      document.getElementById("select-Con").scrollIntoView();
    } else if (iscrange === "") {
      setIscrange("Please select a valid entry.");
      document.getElementById("select-Isc").scrollIntoView();
    } else if (exprange === "") {
      setExprange("Please select a valid entry.");
      document.getElementById("select-Exp").scrollIntoView();
    } else if (stFrange === "") {
      setStFrange("Please select a valid entry.");
      document.getElementById("select-Stf").scrollIntoView();
    } else if (fscrange === "") {
      setfscrange("Please select a valid entry.");
      document.getElementById("select-Fsc").scrollIntoView();
    } else if (vc1range === "") {
      setvc1range("Please select a valid entry.");
      document.getElementById("select-Vc1").scrollIntoView();
    } else if (vc2range === "") {
      setvc2range("Please select a valid entry.");
      document.getElementById("select-Vc2").scrollIntoView();
    } else if (vc3range === "") {
      setvc3range("Please select a valid entry.");
      document.getElementById("select-Vc3").scrollIntoView();
    } else if (vc4range === "") {
      setvc4range("Please select a valid entry.");
      document.getElementById("select-Vc4").scrollIntoView();
    } else if (vc5range === "") {
      setvc5range("Please select a valid entry.");
      document.getElementById("select-Vc5").scrollIntoView();
    } else if (vc6range === "") {
      setvc6range("Please select a valid entry.");
      document.getElementById("select-Vc6").scrollIntoView();
    } else if (mmerange === "") {
      setmmerange("Please select a valid entry.");
      document.getElementById("select-Mme").scrollIntoView();
    } else if (daf1range === "") {
      setDaf1rangeError("Please select a valid entry.");
      document.getElementById("select-Daf1").scrollIntoView();
    } else if (daf2range === "") {
      setDaf2rangeError("Please select a valid entry.");
      document.getElementById("select-Daf2").scrollIntoView();
    } else if (daf3range === "") {
      setDaf3rangeError("Please select a valid entry.");
      document.getElementById("select-Daf3").scrollIntoView();
    } else if (bed2range === "") {
      setBed2rangeError("Please select a valid entry.");
      document.getElementById("select-Bed2").scrollIntoView();
    } else if (bed1range === "") {
      setBed1rangeError("Please select a valid entry.");
      document.getElementById("select-Bed1").scrollIntoView();
    } else if (bed2range === "") {
      setBed2rangeError("Please select a valid entry.");
      document.getElementById("select-Bed2").scrollIntoView();
    } else if (rvnrange === "") {
      setRvnrangeError("Please select a valid entry.");
      document.getElementById("select-Rvn").scrollIntoView();
    } else if (rvn1range === "") {
      setRvn1rangeError("Please select a valid entry.");
      document.getElementById("select-Rvn1").scrollIntoView();
    } else if (pftrange === "") {
      setPftrangeError("Please select a valid entry.");
    } else if (pft1range === "") {
      setPft1rangeError("Please select a valid entry.");
      document.getElementById("select-Pft1").scrollIntoView();
    } else if (bstCrange === "") {
      setBstCrangeError("Please select a valid entry.");
      document.getElementById("select-Bstc").scrollIntoView();
    } else if (bstFrange === "") {
      setBstFrangeError("Please select a valid entry.");
      document.getElementById("select-Bstf").scrollIntoView();
    } else {
      createStartupdataJear({
        variables: {
          EMP: parseInt(emp),
          INT: intrange,
          VAC: vacrange,
          VAC_1: parseInt(vac1),
          NHC: nhcrange,
          CUS_B: parseInt(cusb),
          CUS_E: parseInt(cuse),
          CUS_N: parseInt(cusn),
          DAF_1: daf1range,
          DAF_2: daf2range,
          DAF_3: daf3range,
          BED1: bed1range,
          BED2: bed2range,
          LNK_R: lnkRrange,
          LNK_N: lnkNrange,
          LNK_I: lnkIrange,
          IEV_R: ievRrange,
          IEV_N: ievNrange,
          IEV_I: ievIrange,
          COP: coprange,
          COP_R: copRrange,
          NTW_U: ntwUrange,
          NTW_S: ntwSrange,
          NTW_B: ntwBrange,
          NTW_M: ntwM,
          CON: conrange,
          ISC: iscrange,
          EXP: exprange,
          ST_F: stFrange,
          FSC: fscrange,
          VC_1: vc1range,
          VC_2: vc2range,
          VC_3: vc3range,
          VC_4: vc4range,
          VC_5: vc5range,
          VC_6: vc6range,
          MME: mmerange,
          RVN: rvnrange,
          RVN_1: rvn1range,
          PFT: pftrange,
          PFT_1: pft1range,
          PFT_2: parseInt(pft2),
          BST_C: bstCrange,
          BST_F: bstFrange,
          startupid: startupId,
        },
      });
    }
  };

  return (
    <div className="absolute left-0 right-0 flex flex-col items-center overflow-y-auto bottom-14 top-20">
      {!success && valid && done && (
        <>
          <h1 className="m-2 mt-10">Startup Dates Year</h1>
          <p><strong>All data is collected anonymously and cannot be tracked back to you.</strong></p>  
          <div className="flex flex-wrap">
            <div className="w-full">
              <form onSubmit={handleSubmit} className="w-full max-w-xl p-4 m-auto">
                <h3>Basic Data of Startups</h3>
                <label  className="ml-2 align-middle inline-block">
                  How many employees does your startup currently have?<span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many employees does your startup currently have?"
                  value={emp}
                  onChange={e => setName(e.target.value)}
                ></input>
                <label  className="ml-2 align-middle inline-block">
                  Are you hiring or offering internships?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-int"
                  onChange={handleChangeintrange}
                  options={intranges}
                  placeholder="yes or no"
                />
                {intrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{intrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How many job vacancies are currently open in your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Vac"
                  onChange={handleChangevacrange}
                  options={vacranges}
                  placeholder="How many job vacancies are currently open in your startup?"
                />
                {vacrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vacrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How many of the vacant jobs are subject to social security contributions?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="1-100"
                  value={vac1}
                  onChange={e => setVac1(e.target.value)}
                ></input>
                <label  className="ml-2 align-middle inline-block">
                  How many employees were hired in your startup in the last six months?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Nhc"
                  onChange={handleChangenhcrange}
                  options={nhcranges}
                  placeholder="e.g. 0, 1-2, 3-4..."
                />
                {nhcrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{nhcrangeError}</p>}
                <h3>Customer Score</h3>
                <label  className="ml-2 align-middle inline-block">
                  How many customers did you have at the beginning of this half-year?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many customers did you have at the beginning of this half-year?"
                  value={cusb}
                  onChange={e => setCusb(e.target.value)}
                ></input>
                <label  className="ml-2 align-middle inline-block">
                  How many customers did you have in total at the end of this half-year?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many customers did you have in total at the end of this half-year?"
                  value={cuse}
                  onChange={e => setCuse(e.target.value)}
                ></input>
                <label  className="ml-2 align-middle inline-block">
                  How many new customers did you acquire this half-year?<span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many new customers did you acquire this half-year?"
                  value={cusn}
                  onChange={e => setCusn(e.target.value)}
                ></input>
                <h3>Talent Score</h3>
                <label  className="ml-2 align-middle inline-block">
                  The match is very good between the startup's demands and the employees' personal skills.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Daf1"
                  onChange={handleChangedaf1range}
                  options={daf1ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {daf1rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{daf1rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  The employees' abilities and training are a good fit with the requirements of the startup's jobs.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Daf2"
                  onChange={handleChangedaf2range}
                  options={daf2ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {daf2rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{daf2rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  The employees' personal abilities and education provide a good match with the demands that the startup
                  places on them.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Daf3"
                  onChange={handleChangedaf3range}
                  options={daf3ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {daf3rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{daf3rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  Our talent pool is sufficient to handle the current workload.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed1"
                  onChange={handleChangeBed1range}
                  options={bed1ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {bed1rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{bed1rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  My startup is able to attract suitable talent for upcoming tasks in the future.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed2"
                  onChange={handleChangeBed2range}
                  options={bed2ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {bed2rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{bed2rangeError}</p>}
                <h3>Networking Score</h3>
                <label  className="ml-2 align-middle inline-block">
                  I am well linked with other startups on a regional level.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Lnkr"
                  onChange={handleChangelnkRrange}
                  options={lnkRranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {lnkRrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{lnkRrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  I am well linked with other startups on a national level.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Lnkn"
                  onChange={handleChangelnkNrange}
                  options={lnkNranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {lnkNrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{lnkNrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  I am well linked with other startups on a international level.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Lnki"
                  onChange={handleChangelnkIrange}
                  options={lnkIranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {lnkIrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{lnkIrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How often do you attend regional startup/investor/networking events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievr"
                  onChange={handleChangeievRrange}
                  options={ievRranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievRrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{ievRrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How often do you attend national startup/investor/networking events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievn"
                  onChange={handleChangeievNrange}
                  options={ievNranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievNrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{ievNrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How often do you attend international startup/investor/networking events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievi"
                  onChange={handleChangeievIrange}
                  options={ievIranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievIrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{ievIrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  Our startup cooperates with...
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Cop"
                  onChange={handleChangecoprange}
                  options={copranges}
                  placeholder="e.g. … estabilished companies, … other startups..."
                />
                {coprangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{coprangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How do you rate these collaborations overall?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-CopR"
                  onChange={handleChangecopRrange}
                  options={copRranges}
                  placeholder="e.g. positive, satisfactory, unfavorable..."
                />
                {copRrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{copRrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What networking channels do you use for your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-NtwU"
                  onChange={handleChangentwUrange}
                  options={ntwUranges}
                  placeholder="e.g. digital channels (e.g., LinkedIn, Xing), Meetups, Conferences ..."
                />
                {ntwUrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{ntwUrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What networking channels have proven successful for you?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-NtwS"
                  onChange={handleChangentwSrange}
                  options={ntwSranges}
                  placeholder="e.g. digital channels (e.g., LinkedIn, Xing), Meetups, Conferences ..."
                />
                {ntwSrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{ntwSrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How do you benefit from your network?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-NtwB"
                  onChange={handleChangentwBrange}
                  options={ntwBranges}
                  placeholder="e.g. talent exchange, contact exchange, knowledge sharing ..."
                />
                {ntwBrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{ntwBrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What support is missing from your network?<span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="text"
                  placeholder="What support is missing from your network?"
                  value={ntwM}
                  onChange={e => setntwM(e.target.value)}
                ></input>
                <label  className="ml-2 align-middle inline-block">
                  When was the last time you provided customer leads to another startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Con"
                  onChange={handleChangeconrange}
                  options={conranges}
                  placeholder="e.g. this month, last month, 2-3 months ago ..."
                />
                {conrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{conrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  I feel well connected in the VC and investor scene.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Isc"
                  onChange={handleChangeiscrange}
                  options={iscranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {iscrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{iscrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  I am interested in expanding my network. Please inform me about networking events in my region.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Exp"
                  onChange={handleChangeexprange}
                  options={expranges}
                  placeholder="e.g. Yes, No ..."
                />
                {exprangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{exprangeError}</p>}
                <h3>Investment Score</h3>
                <label  className="ml-2 align-middle inline-block">
                  What is the current funding situation of your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Stf"
                  onChange={handleChangestFrange}
                  options={stFranges}
                  placeholder="e.g. Seed Capital, Angel Investor Funding..."
                />
                {stFrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{stFrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What are the overall funding sources for your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Rvn"
                  onChange={handleChangefscrange}
                  options={fscranges}
                  placeholder="e.g. Own savings, Cashflow, Family & Friends..."
                />
                {fscrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{fscrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  Which funding stage did you already close?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Vc1"
                  onChange={handleChangevc1range}
                  options={vc1ranges}
                  placeholder="e.g. Seed Capital, Series A, Series B..."
                />
                {vc1rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vc1rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What were the venture capital sources of your last funding round?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Vc2"
                  onChange={handleChangevc2range}
                  options={vc2ranges}
                  placeholder="e.g. Family&Friends,Business Angels, Government funding ..."
                />
                {vc2rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vc2rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  Which regions do most of your investors come from? (all funding rounds)
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Vc3"
                  onChange={handleChangevc3range}
                  options={vc3ranges}
                  placeholder="e.g. regional, national, international..."
                />
                {vc3rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vc3rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What is the current total funding volume of your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-vc4"
                  onChange={handleChangevc4range}
                  options={vc4ranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {vc4rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vc4rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  When is the next investment round planned?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-vc5"
                  onChange={handleChangevc5range}
                  options={vc5ranges}
                  placeholder="e.g. no investment round planned to date, > 2 years..."
                />
                {vc5rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vc5rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What is the planed investment volume for the next funding round?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-vc6"
                  onChange={handleChangevc6range}
                  options={vc6ranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {vc6rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{vc6rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  Are you interested in investor match-making events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Mme"
                  onChange={handleChangemmerange}
                  options={mmeranges}
                  placeholder="e.g. Yes, No..."
                />
                {mmerangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{mmerangeError}</p>}
                <h3>Business Score</h3>
                <label  className="ml-2 align-middle inline-block">
                  In the last year, how much revenue did you generate with your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Rvn"
                  onChange={handleChangervnrange}
                  options={rvnranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {rvnrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{rvnrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What is the expected revenue in the upcoming year?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Rvn1"
                  onChange={handleChangervn1range}
                  options={rvn1ranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {rvn1rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{rvn1rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  In the last year, how much profit did you generate with your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-pft"
                  onChange={handleChangePftrange}
                  options={pftranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {pftrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{pftrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  What is the expected profit in the upcoming year?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Pft1"
                  onChange={handleChangePft1range}
                  options={pft1ranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {pft1rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{pft1rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  When is the first profit expected?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="When is the first profit expected?"
                  value={pft2}
                  onChange={e => setPft2(e.target.value)}
                ></input>
                <label  className="ml-2 align-middle inline-block">
                  How do you assess the current business situation?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bstc"
                  onChange={handleChangeBstCrange}
                  options={bstCranges}
                  placeholder="e.g. Optimistic, Neutral ..."
                />
                {bstCrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{bstCrangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                  How do you assess the business situation in the next 6 months?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bstf"
                  onChange={handleChangeBstFrange}
                  options={bstFranges}
                  placeholder="e.g. Optimistic, Neutral ..."
                />
                {bstFrangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{bstFrangeError}</p>}

                <div className="flex mt-4 mb-6 ml-2 text-left items-left">
                  <input required id="privacy" type="checkbox"></input>
                  <label htmlFor="privacy" className="ml-2 align-middle inline-block">
                    I agree to the <a href="https://station-frankfurt.de/datenschutzerklaerung/">privacy policy.</a>
                    <span className="required">*</span>
                  </label>
                </div>
                <button
                  id="submit"
                  type="submit"
                  className="w-full mb-4 tertiary link-bold"
                  disabled={loadingStartupdataJear}
                >
                  Submit form
                </button>
              </form>
            </div>
          </div>
        </>
      )}
      {success && done && valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>We have received the registration of your Startup Dates Year.</h2>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">Back to the map</li>
          </Link>
        </div>
      )}
      {done && !valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>There was an error with your token.</h2>
          <p className="mt-4 text-copy-main-regular">Please verify that your link is valid and not expired.</p>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">Back to map</li>
          </Link>
        </div>
      )}
    </div>
  );
}

export default StartupdatJear;
